import { create } from 'zustand';
import { GrupoAcessoResume } from '../../types/administracao/grupoAcesso';
import { administracaoAPI } from '../../api';

interface GrupoAcessoState {
  grupoAcessoResume: GrupoAcessoResume[]
  setGrupoAcessoResume: () => Promise<void>
  erroGrupoAcessoResume: boolean
  loadingGrupoAcessoResume: boolean
  setErroGrupoAcessoResume: (erro: boolean) => void
  cleanGrupoAcessoState: () => void
}

export const useGrupoAcessoStore = create<GrupoAcessoState>((set) => ({
  grupoAcessoResume: [],
  erroGrupoAcessoResume: false,
  loadingGrupoAcessoResume: false,
  setGrupoAcessoResume: async () => {
    set(() => ({ loadingGrupoAcessoResume: true, erroGrupoAcessoResume: false }))
    const result = await administracaoAPI.getGrupoAcessoResume()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ grupoAcessoResume: result.data }))
    }
    else {
      set(() => ({ erroGrupoAcessoResume: true, grupoAcessoResume: [] }))
    }
    set(() => ({ loadingGrupoAcessoResume: false }))
  },
  setErroGrupoAcessoResume: (erro: boolean) => {
    set(() => ({ erroGrupoAcessoResume: erro }))
  },
  cleanGrupoAcessoState: () => {
    set(() => ({ grupoAcessoResume: [], erroGrupoAcessoResume: false, loadingGrupoAcessoResume: false }))
  }
}))